import { render, staticRenderFns } from "./Postbox.vue?vue&type=template&id=3dc482a3"
import script from "./Postbox.vue?vue&type=script&lang=js"
export * from "./Postbox.vue?vue&type=script&lang=js"
import style0 from "./Postbox.vue?vue&type=style&index=0&id=3dc482a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports